module.exports = {"id":"223627","name":"Omar Al Soma","rating":"78","photo":"./data/images/photos/0/223627.png","club":{"name":"Al Ahli","logo":"./data/images/clubs/AlAhli.png"},"positions":["BU"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/OmarAlSoma0.json
// module id = 3274
// module chunks = 0